import * as React from "react";
import { getHumanReadableDateTime } from '../../util/DateUtil';
import Box from "@amzn/awsui-components-react-v3/polaris/box";
import { TimezoneHintPopover } from "./TimezoneHintPopover";

interface ZonedDateTimeProps {
    timeInEpochMilli: string | undefined,
    timezoneIANA: string,
    dateTimeFormat: string
}

export const ZonedDateTime = (props:ZonedDateTimeProps) => {
    const dateDisplayed = getHumanReadableDateTime(props.timeInEpochMilli, props.timezoneIANA, props.dateTimeFormat);

    return (
        <Box>
            {
                dateDisplayed ? 
                <Box variant="span"> 
                    {dateDisplayed} <TimezoneHintPopover timezoneIANA={props.timezoneIANA}></TimezoneHintPopover>
                </Box> : <Box variant="span">-</Box>
            }
        </Box>
    )
}